import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  FindVehicleData,
  FindVehicleEntity,
  FindVehicleError,
  VehicleInfo,
} from "./interfaces";

const initialState: FindVehicleEntity = {
  current: null,
  isLoading: false,
  error: null,
};

const findVehicleSlice = createSlice({
  name: "findVehicle",
  initialState,
  reducers: {
    resetFindVehicle: (state) => {
      state.current = null;
      state.isLoading = false;
      state.error = null;
    },

    findVehicleStart: (state, _action: PayloadAction<FindVehicleData>) => {
      state.isLoading = true;
    },

    findVehicleSucceeded: (state, action: PayloadAction<VehicleInfo>) => {
      state.current = {
        ...state.current,
        ...action.payload,
      };
      state.isLoading = false;
      state.error = null;
    },

    operationFailed: (state, action: PayloadAction<FindVehicleError>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  findVehicleStart,
  findVehicleSucceeded,
  operationFailed,
  resetFindVehicle,
} = findVehicleSlice.actions;
export const findVehicle = findVehicleSlice.reducer;
